import { createComponent, createElement, ref } from "@vue/composition-api";
import DecisionCard from "./DecisionCard.vue";
import { useActions } from "@/shared/useMegaraxClient";
import {
  decisionResource,
  Decision,
} from "@megarax/client/src/resources/Decision";
import SpinnerCard from "@/components/SpinnerCard.vue";
interface Props {
  id?: number;
}

export default createComponent<Props>({
  name: "DecisionItemView",
  props: { id: { required: false } },
  setup(props, { root }) {
    const id = props.id || root.$route.params.id;
    const decision = ref<Decision | null>(null);

    useActions(decisionResource)
      .fetchItem(id)
      .then((d) => (decision.value = d));

    return () =>
      decision.value
        ? createElement(DecisionCard, {
            props: {
              value: decision.value,
            },
          })
        : createElement(SpinnerCard);
  },
});
